export default __webpack_public_path__ + "static/media/arrow-down-right.68e26ea4.svg";